import { render, staticRenderFns } from "./question-choice.vue?vue&type=template&id=866a6e6e&scoped=true&"
import script from "./question-choice.vue?vue&type=script&lang=js&"
export * from "./question-choice.vue?vue&type=script&lang=js&"
import style0 from "./question-choice.vue?vue&type=style&index=0&id=866a6e6e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866a6e6e",
  null
  
)

export default component.exports